"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LS_EXCHANGE_TOKEN_KEY = exports.DEFAULT_LS_REFRESH_TOKEN_KEY = exports.DEFAULT_LS_ACCESS_TOKEN_KEY = void 0;
exports.DEFAULT_LS_ACCESS_TOKEN_KEY = '__AUTH__TOKEN__';
exports.DEFAULT_LS_REFRESH_TOKEN_KEY = '__AUTH__REFRESH__TOKEN__';
exports.DEFAULT_LS_EXCHANGE_TOKEN_KEY = '__EXCHANGE__TOKEN__';
